import React from 'react';

const Footer = () => {
    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-8">
                        <h1>GET THE LATEST<br/>MARSHA DROPS FIRST</h1>
                        <p>Get exclusive early access to new drops, limited-time deals and<br/> insider content delivered straight to your inbox.</p>
                    </div>

                    <div className="col-4">
                        <p>Newsletter for Men and Women shop</p>
                        <div className="wt-block d-flex">
                            <input name="subscribe" placeholder="ENTER EMAIL ADDRESS" className="form-control mr-2 flex-fill"/>
                            <button className="btn btn-primary btn-black" type="submit">SUBSCRIBE</button>
                        </div>
                        <span>We respect your privacy and won’t spam you. Unsubscribe anytime. See our Privacy Policy for details</span>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-12 col-md-3">
                        <h6>Follow us on Social</h6>
                        <ul className="list-unstyled">
                            <li className="list-inline-item"><i className="fa fa-facebook"></i></li>
                            <li className="list-inline-item"><i className="fa fa-instagram"></i></li>
                            <li className="list-inline-item"><i className="fa fa-twitter"></i></li>
                        </ul>
                    </div>

                    <div className="col-12 col-md-3">
                        <h6>Give us a call</h6>
                        <h5>(260) 564 567 234</h5>
                    </div>

                    <div className="col-12 col-md-3">
                        <h6>Send us an email</h6>
                        <h5>info@marsha.com</h5>
                    </div>

                    <div className="col-12 col-md-3">
                        <h6>Visit us in person</h6>
                        <h5>Kabulonga, Lusaka Zambia</h5>
                    </div>
                </div>

                <hr/>

                <p className="text-center mt-4">&copy; Copyright {new Date().getFullYear()}, Marsha.</p>
            </div>
        </footer>
    );
};

export default Footer;
